export default __webpack_public_path__ + "static/media/newsletter-default.3127de82.jpg";